function initInputs() {
  let allInputs = document.querySelectorAll('.field .field__input');
  
  allInputs.forEach(inp => {
    const updateLabel = () => {
      let inpLabel = inp.parentElement.querySelector('.field__label');
      if (inp.value.length > 0) {
        inpLabel.style.display = 'none';
      } else {
        inpLabel.style.display = 'block';
      }
    };

    // Run once on load
    updateLabel();

    // Also run on every user input
    inp.addEventListener('input', updateLabel);
  });
}
document.addEventListener('DOMContentLoaded', function () {
  initInputs();
});
